import { render, staticRenderFns } from "./bindInformation.vue?vue&type=template&id=3feabd51&scoped=true"
import script from "./bindInformation.vue?vue&type=script&lang=js"
export * from "./bindInformation.vue?vue&type=script&lang=js"
import style0 from "./bindInformation.vue?vue&type=style&index=0&id=3feabd51&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feabd51",
  null
  
)

export default component.exports